import React from 'react';

import Page from 'app/containers/parts/Page';
import CustomHelmet from 'app/components/commons/CustomHelmet';
import SwapRules from 'app/components/playerSwap/SwapRules';
import styled from '@emotion/styled';

const Wrapper = styled.div(props => ({
  paddingLeft: props.theme.spacing.small,
  paddingRight: props.theme.spacing.small
}));

const SwapRulesPage = () => {
  return (
    <Page>
      <CustomHelmet description="Swap Rules" htmlTitle="Swap Rules" title="Swap Rules" />
      <Wrapper>
        <SwapRules />
      </Wrapper>
    </Page>
  );
};

export default SwapRulesPage;
